import ChatIcon from "@mui/icons-material/Chat";
import CloseIcon from '@mui/icons-material/Close';
import SendIcon from "@mui/icons-material/Send";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ThumbUpOffAltIcon from "@mui/icons-material/ThumbUpOffAlt";
import WarningIcon from "@mui/icons-material/Warning";
import { Avatar, Box, Button, DialogActions, DialogContent, IconButton, Skeleton, TextField, Typography } from '@mui/material';
import { formatDistanceToNow } from 'date-fns';
import { useCallback, useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { SCAMALERT_FILES_URL, USER_FILES_URL } from "src/api_endpoints/API_URL";
import {
  createComment,
  deleteReplyOnCommentApi,
  getCommentsByScamId,
  getSingleScamPostbyScamIdApi,
  fetchAllScamsAlertsWithReactionsApi,
  postReplyToCommentApi,
  toggleReplyReactionApi,
  updateReaction,
  fetchRedirectionLinksApi
} from "src/api_endpoints/userDashboard/ScamAPI";
import { showToast } from "src/redux/common/commonActions";
import { incCommentCount } from "src/redux/scam/scamActions";
import FrontHeader from "../../components/front-end/Header";
import Footer from "../../components/front-end/footer";
import ConfirmationModal from "./ConfirmationModal";
import ScamAlertCommonCard from "./ScamAlertCommonCard";
import ViewScamImagesModal from "./viewScamImagesModal";
const SingleScamPost = () => {
  const { id: userId, first_name, last_name, user_avatar } = useSelector((state) => state.userState?.userData);
  let { id } = useParams();
  const currentLocation = useLocation();
  const params = new URLSearchParams(currentLocation.search);
  const isViewMyReports = params.get("my_reports")
  id = id.includes("_scam_") ? id.split("_scam_").pop() : id;
  const navigate = useNavigate()
  const [scam, setScam] = useState(null);
  const [scamComments, setScamComments] = useState([]);
  const [replyInputs, setReplyInputs] = useState({});
  const [replyData, setReplyData] = useState({});
  const [openModal, setOpenModal] = useState(false);
  const [currentImages, setCurrentImages] = useState([]);
  const [deleteScamId, setDeleteScamId] = useState(null)
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [error, setError] = useState(false);
  const [comment, setComment] = useState('');
  const inputRef = useRef(null);
  const [currentScamComments, setCurrentScamComments] = useState([]);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [refresh, setRefresh] = useState(true)
  const [loading, setLoading] = useState(true);
  const [replyToDelete, setReplyToDelete] = useState(null); // To store the reply being deleted
  const [replyIndexToDelete, setReplyIndexToDelete] = useState(null);
  const { isLoggedIn } = useSelector((state) => state.userState);
  const [posts, setPosts] = useState([]);
  const [redirectionLinks, setRedirectionLinks] = useState([]);

  const [metaData, setMetaData] = useState({});

  const dispatch = useDispatch()
  const commentsEndRef = useRef(null);



  useEffect(() => {
    fetchScamDetails();
  }, [id, refresh]);

  const fetchScamDetails = async () => {
    if (!id) return;
    try {
      const response = await getSingleScamPostbyScamIdApi({ user_id: userId, scamPK: id });
      // console.log(response)
      if (!response.error) {
        setScam(response);
      }
    } catch (error) {
      console.error("Failed to fetch scam details:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (scam) fetchScamComments();
  }, [scam]);

  const fetchScamComments = async () => {
    if (!id) return;
    try {
      const response = await getCommentsByScamId({ scam_id: id, user_id: userId });
      setScamComments(response?.comments);
    } catch (error) {
      console.error("Failed to fetch scam comments:", error);
    }
  };

  const handleCreateComment = async (comment, scamId) => {
    try {
      const res = await createComment({
        user_id: userId,
        scam_id: scamId,
        comment
      });

      if (res && res.commentId) {
        dispatch(incCommentCount(scamId));
        setCurrentScamComments((prevComments) => [
          ...prevComments,
          {
            user_id: userId,
            comment,
            status: 1, // Assuming the new comment is active by default
            date_created: new Date().toISOString(), // Current timestamp in ISO format
            first_name, // Replace with dynamic values
            last_name,
            user_avatar,
            id: res.commentId
          }
        ]);
      } else {
        // throw new Error(res?.message || "Failed to create comment");
        dispatch(showToast({ show: true, msg: res.errTypeData.response.data.message }));

      }
    } catch (error) {
      console.error("Error creating comment:", error.message);
      dispatch(showToast({ show: true, msg: error.message || "Something went wrong!" }));
    }
  };

  const handleSendClick = () => {
    if (comment.trim() === '') {
      setError(true);
      return;
    }
    handleCreateComment(comment, scam.scamPK);
    setComment('');
    setRefresh(p => !p)
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };
  const handleDeleteClick = (index, reply) => {
    setReplyToDelete(reply);
    setReplyIndexToDelete(index);
    setIsModalOpen(true); // Open the confirmation modal
  };

  const handleReaction = async (scamId, newReaction) => {
    try {
      const formData = new FormData();
      formData.append("scam_code", scamId);
      formData.append("user_id", userId);
      formData.append("reaction_type", newReaction);

      const res = await updateReaction(formData);
      if (res.error) {
        dispatch(showToast({ show: true, msg: res.errTypeData.response.data.error || 'Failed to react!' }));
      } else {
        fetchScamDetails();
      }
    } catch (err) {
      console.error("Failed to update reaction:", err);
    }
  };

  const handleReplyChange = (index, value) => {
    setReplyData((prev) => ({ ...prev, [index]: value }));
  };

  const handleReplySend = async (index, scam_comment_id) => {
    if (!replyData[index]?.trim()) return;
    const payload = {
      scam_comment_id,
      user_id: userId,
      reply_comment: replyData[index],
    };
    try {
      const res = await postReplyToCommentApi(payload);
      if (res.success) {
        setReplyData({})
        setRefresh(p => !p)
      } else {
        dispatch(showToast({ show: true, msg: res.errTypeData.response.data.message || 'Failed to reply!' }));
      }
    } catch (error) {
      console.error("Error posting reply:", error);
    }
  };

  const handleToggleLike = async (index, scam_comment_id, isLikedComment, totalLikesOnReplyComment) => {
    try {
      const res = await toggleReplyReactionApi({ reply_id: scam_comment_id, user_id: userId });
      res.success ? fetchScamComments() : dispatch(showToast({ show: true, msg: res.errTypeData.response.data.message }));
    } catch (error) {
      console.error("Error toggling like:", error);
    }
  };

  const toggleReplyInput = (index) => {
    setReplyInputs((prev) => ({ ...prev, [index]: !prev[index] }));
  };


  const handleOpenModal = (images) => {
    setCurrentImages(images);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };
  // console.log(scamComments)

  const removeReply = async (index, reply) => {
    // console.log(reply)
    const { scam_comment_id, id: reply_id } = reply;

    const payload = {
      reply_id,
      user_id: userId,
    };

    try {
      const response = await deleteReplyOnCommentApi(payload);

      setIsModalOpen(false);
      if (response.success) {
        setRefresh(p => !p)
      } else {
        console.error('Failed to delete reply:', response);
      }
    } catch (error) {
      console.error('Error deleting reply:', error);
    }
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleCommentChange = (e) => {
    setComment(e.target.value);
    if (e.target.value.trim() !== '') {
      setError(false);
    }
  };
  const cancelConfirm = () => {
    setShowConfirmationModal(false);
  };
  useEffect(() => {
    if (commentsEndRef.current) {
      commentsEndRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' });
    }
  }, [scamComments]); // Runs whenever scamComments update

  useEffect(() => {
    if (scam) {
      setMetaData({
        title: `Scam Alert: ${scam.scam_code}`,
        description: scam.description?.slice(0, 150)
      });
    }
  }, [scam]);


  const fetchRedirectionLinks = useCallback(async () => {
    try {
      // const res = await fetchAllScamsAlertsWithReactionsApi();
      const res = await fetchRedirectionLinksApi();
      if (res?.scams) {
        setRedirectionLinks(res.scams);
      } else {
        console.error("No RedirectionLinks found.");
      }
    } catch (error) {
      console.error("Error fetching scam alerts:", error);
    }
  }, []);

  useEffect(() => {
    fetchRedirectionLinks();
  }, [fetchRedirectionLinks]);


  // console.log(redirectionLinks);
  // console.log(scam)
  // console.log(metaData)

  const scamId = parseInt(id, 10);
  const currentIndex = redirectionLinks.findIndex((scam) => scam.scamPK === scamId);

  const prevScam = currentIndex > 0 ? redirectionLinks[currentIndex - 1] : null;
  const nextScam = currentIndex < redirectionLinks.length - 1 ? redirectionLinks[currentIndex + 1] : null;

  // Generate navigation URLs
  const generateScamUrl = (scam) =>
    isLoggedIn
      ? `/client-expert/report-a-scam/${scam.first_name}_${scam.scam_code}_scam_${scam.scamPK}?my_reports=${isViewMyReports}`
      : `/report-a-scam/${scam.first_name}_${scam.scam_code}_scam_${scam.scamPK}?my_reports=${isViewMyReports}`;

  return (
    <>
      <Helmet>
        <title>{metaData?.title?.trim() ? metaData.title : "Scam Alert | Protect Freelancers"}</title>
        <meta
          name="description"
          content={metaData?.description?.trim() ? metaData.description : "Report scam clients or freelancers to keep the community safe."}
        />
      </Helmet>
      {
        !isLoggedIn && <FrontHeader />
      }
      {loading ? (
        <Box sx={{ width: '70%', margin: 'auto', padding: 2 }}>
          <Skeleton variant="text" width="40%" height={30} />
          <Skeleton variant="rectangular" width="100%" height={200} sx={{ borderRadius: 2 }} />
          <Skeleton variant="text" width="80%" height={20} sx={{ marginTop: 1 }} />
          <Skeleton variant="text" width="60%" height={20} />
          <Skeleton variant="circular" width={40} height={40} sx={{ marginTop: 2 }} />
          <Skeleton variant="rectangular" width="100%" height={150} sx={{ borderRadius: 2, marginTop: 2 }} />
        </Box>
      ) : scam ? (
        <Box sx={{
          width: {
            xs: '100%', sm: '90%', md: '80%', lg: '70%'
          },
          maxWidth: '50rem',
          margin: 'auto',
          marginTop: !isLoggedIn ? '5rem' : '0',
        }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography variant="h6" className="pl-2 my-2" sx={{
              color: '#f44336',
            }}>
              Scam alert
            </Typography>
            <Typography>
              <WarningIcon color="error" />
            </Typography>
          </Box>

          <ScamAlertCommonCard
            scam={scam}
            onReaction={handleReaction}
            isViewMyReports={false}
            fromSingleScamPost={true}
            onOpenModal={handleOpenModal}
            onCloseModal={handleCloseModal}
            setDeleteScamId={setDeleteScamId}
            isLoggedIn={isLoggedIn}
          />
          <DialogActions sx={{
            width: { xs: "100%", md: "30rem" }, // 100% for small screens, 30rem for md and above
            maxWidth: "100%", // Prevents overflow
          }}>
            <TextField
              fullWidth
              placeholder="Write a comment..."
              value={comment}
              onChange={handleCommentChange}
              error={error}
              inputRef={inputRef}
              sx={{ "& .MuiInputBase-input": { padding: "12px" } }}
            />
            <IconButton color="primary"
              onClick={handleSendClick}
            >
              <SendIcon />
            </IconButton>
          </DialogActions>
          <DialogContent sx={{
            //  maxHeight: '400px', overflowY: 'auto', 
            padding: '1rem'
          }}>
            {scamComments.length > 0 &&
              scamComments.map(
                ({
                  id: scam_comment_id, scam_id,
                  first_name,
                  last_name,
                  user_avatar,
                  date_created,
                  comment,
                  isLikedComment,
                  totalRepliesOnComment,
                  totalLikesOnReplyComment,
                  replies = [],
                }, index) => (
                  <Box
                    key={scam_comment_id}
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '0.3rem',
                      marginBottom: '.5rem',
                      borderRadius: '.6rem',
                      backgroundColor: '#f7f4f4',
                      padding: '1rem 1rem 0.5rem 1rem',
                    }}
                  >
                    <Box sx={{ display: 'flex', gap: '0.5rem' }}>
                      <Avatar src={USER_FILES_URL + user_avatar} alt={first_name} />
                      <Box className="flex justify-between items-baseline w-full">
                        <Box sx={{ fontWeight: 'bold' }}>
                          {first_name} {last_name}
                        </Box>
                        <Box sx={{ fontSize: '0.8rem', color: 'gray' }}>
                          {formatDistanceToNow(new Date(date_created))}
                          {/* , { addSuffix: true } */}
                        </Box>
                      </Box>
                    </Box>
                    <Box sx={{ paddingLeft: '3rem', marginTop: '-1.4rem' }}>{comment}</Box>
                    <Box className="flex gap-1 sm:pl-8">
                      <Typography className="flex items-center">
                        <IconButton
                          onClick={() => handleToggleLike(index, scam_comment_id,
                            isLikedComment,
                            totalRepliesOnComment)}
                        >
                          {isLikedComment ? <ThumbUpIcon fontSize="small" /> : <ThumbUpOffAltIcon fontSize="small" />}
                        </IconButton>
                        Like {totalLikesOnReplyComment > 0 && totalLikesOnReplyComment}
                      </Typography>
                      <Typography className="flex items-center">
                        <IconButton
                          onClick={() => toggleReplyInput(index)}
                        >
                          <ChatIcon fontSize="small" />
                        </IconButton>
                        Reply
                      </Typography>
                      {totalRepliesOnComment > 0 && (
                        <Box className="flex items-center pl-1">
                          |{' '}
                          <Typography sx={{ color: '#8181fb', paddingLeft: '.5rem' }}>
                            {totalRepliesOnComment} {totalRepliesOnComment === 1 ? 'Reaction' : 'Reactions'}
                          </Typography>
                        </Box>
                      )}
                    </Box>
                    {replyInputs[index] && (
                      <Box className="pl-8 mb-2 flex gap-2">
                        <TextField
                          size="small"
                          placeholder="Write a reply..."
                          value={replyData[index] || ''}
                          onChange={(e) => handleReplyChange(index, e.target.value)}
                          fullWidth
                        />
                        <IconButton color="primary" onClick={() => handleReplySend(index, scam_comment_id)}>
                          <SendIcon />
                        </IconButton>
                      </Box>
                    )}


                    {replies.map((reply, replyIndex) => (
                      <Box
                        key={replyIndex}
                        sx={{
                          paddingLeft: '4rem',
                          backgroundColor: '#e9e9e9',
                          padding: '.5rem 1rem',
                          borderRadius: '.4rem',
                          position: 'relative',
                        }}
                      >
                        <Box className="flex gap-2">
                          <Avatar
                            src={USER_FILES_URL + reply.user_avatar}
                            alt={reply.first_name}
                            sx={{ width: 30, height: 30 }}
                          />
                          <Box>
                            <Typography sx={{ fontWeight: 'bold' }}>
                              {reply.first_name} {reply.last_name}
                            </Typography>
                            <Typography>{reply.reply_comment}</Typography>
                          </Box>
                        </Box>
                        {userId === reply.user_id && (
                          <IconButton size="small" sx={{ position: 'absolute', top: 1, right: 1 }}
                            onClick={() => handleDeleteClick(index, reply)}
                          >
                            <CloseIcon fontSize="small" />
                          </IconButton>
                        )}
                      </Box>
                    ))}
                  </Box>
                )
              )}
            <div ref={commentsEndRef} />
          </DialogContent>
          {/* Previous and Next Button */}
          {
            isViewMyReports == 'false' &&
            <Box display="flex" justifyContent="space-between" my={5}>
              <Button
                variant="contained"
                color="primary"
                disabled={!prevScam}
                onClick={() => prevScam && navigate(generateScamUrl(prevScam))}
              >
                Previous
              </Button>
              <Button
                variant="contained"
                color="primary"
                disabled={!nextScam}
                onClick={() => nextScam && navigate(generateScamUrl(nextScam))}
              >
                Next
              </Button>
            </Box>
          }
          {isModalOpen && (
            <ConfirmationModal
              text="Are you sure you want to delete this reply?"
              onConfirm={() => removeReply(replyIndexToDelete, replyToDelete)} // Confirm deletion
              onCancel={handleCancel} // Close modal on cancel
            />
          )}
          <ViewScamImagesModal
            openModal={openModal}
            handleCloseModal={handleCloseModal}
            currentImages={currentImages}
          />
          {showConfirmationModal && <ConfirmationModal text="Do you want to delete?" onConfirm={removeReply} onCancel={cancelConfirm} />}

        </Box>
      ) : (
        <Box className="h-[50vh] flex justify-center items-center"
        >No scam found.</Box>
      )}
      {
        !isLoggedIn && <Footer />
      }
    </>

  );
};

export default SingleScamPost;